import scanner from './scanner'
import translator from './translator'
import wiper from './wiper'

export default [scanner, translator, wiper]



// WEBPACK FOOTER //
// ./src/store/middlewares/index.js